import React, {h} from 'preact';
import SellContactFormStep from './SellContactFormStep';

const PROVIDER_NAMES_BY_KEY = {
    facebook: 'Facebook',
    google: 'Google',
    linkedin: 'LinkedIn',
    apple: 'Apple'
};

export default class SellContactFormStep2 extends SellContactFormStep {
    constructor(props) {
        super(props);
        this.hasAddressBeenValidated = true;
        this.validationPromise = $.Deferred().resolve({});
    }

    componentDidMount() {
        super.componentDidMount();
        const {
            addressDetails,
            state: {homeType}
        } = this.props.parent;

        const eventProperties = {
            abTestWHYVersion: window.abTestWHYVersion,
            sellerEnteredUnitNumberOnStep5: !!addressDetails?.unit
        };

        if (!['Condominium', 'Townhouse'].includes(homeType)) {
            delete eventProperties.sellerEnteredUnitNumberOnStep5;
        }
        trackEvent('Flow', 'SellRequest', 'sellerRequestStep6PageLoad', eventProperties)
            .withGA()
            .withOptimizely();

        if ($(this.refs.phone).val()) {
            this.setState({isPhoneVisible: true});
        }
    }

    render() {
        if (this.props.realtorId) {
            return (
                <i
                    className="fa fa-spinner fa-pulse"
                    style="color:#aaa;font-size:70px;margin:200px auto 0;position:relative;text-align:center;width:100%"
                />
            );
        }

        const {
            userExists,
            isLoggedIn,
            loginProvider,
            selectedLoginProvider,
            isPerformingSocialLogin,
            isPhoneVisible,
            isNotValidEmail,
            errors
        } = this.state;
        const loginProviderName = PROVIDER_NAMES_BY_KEY[loginProvider];

        return (
            <div id="sell-flow-step5" className="flow-step">
                <div id="contact-form-top-text">
                    <img src={this.props.amPhoto} className="img-circle pull-left mobile-buy-sell-flow-ua-img" />
                    <div>
                        You will receive a <b>free home value analysis</b> and{' '}
                        <b>3 - 5 proposals from our top agents.</b>
                    </div>
                </div>
                <div className="flow-step-header-text">
                    <strong>Where should we email your free agent proposals?</strong>
                </div>

                <form ref={elem => (this.refs.form = elem)}>
                    <div
                        className={`float-label-div${!!loginProvider && !!isLoggedIn ? ' disabled' : ''}`}
                        style={{position: 'relative'}}>
                        <input
                            id="email"
                            className="email required"
                            type="email"
                            name="email"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoComplete="email"
                            disabled={!!loginProvider && !!isLoggedIn}
                            ref={elem => (this.refs.email = elem)}
                            onKeyDown={this.onEmailKeyDown.bind(this)}
                            onInput={this.onEmailInput.bind(this)}
                            onBlur={() => {
                                this.handleValidation(this.refs.email);
                                this.handleValidateEmailFormat();
                            }}
                        />
                        <label htmlFor="email" className="float-label required">
                            Email
                        </label>
                        {userExists && (
                            <span id="welcomeBack" className="secondary-label required" data-hb-ref="welcomeBackLabel">
                                Welcome Back!
                            </span>
                        )}
                        <i className="contact-form-icon icon-contact-email-outline" />
                        {!!errors.email && (
                            <label htmlFor="email" generated="true" className="error">
                                {errors.email}
                            </label>
                        )}
                        {!errors.email && !!loginProvider && !!isLoggedIn && (
                            <div className="check-mark">
                                <i className="icon-nav-check" />
                            </div>
                        )}
                    </div>
                    <div className={'float-label-div ' + (isPhoneVisible ? '' : ' hidden')}>
                        <input
                            ref={elem => (this.refs.phone = elem)}
                            id="phone"
                            className="phoneUS required"
                            maxLength={this.props.isNotUS ? '11' : '14'}
                            type="tel"
                            name="phone"
                            autoComplete="tel"
                            onBlur={() => this.handleValidation(this.refs.phone, !$(this.refs.phone).val())}
                            onKeyPress={event => this.onPhoneChange(event, this.props.country)}
                        />
                        <label htmlFor="phone" className="float-label">
                            Phone for account verification (required)
                        </label>
                        <i className="contact-form-icon icon-contact-phone-outline" />
                        {!!errors.phone && (
                            <label htmlFor="phone" generated="true" className="error">
                                {errors.phone}
                            </label>
                        )}
                    </div>

                    {window.SELL_SOCIAL_LOGIN_ENABLED && (
                        <div
                            className={
                                'social-login-chooser social-login-chooser-buy-sell-flow ' +
                                (loginProvider || isLoggedIn || isPerformingSocialLogin ? ' hidden' : '')
                            }>
                            <div className="hidden-xs status-normal social-text">Or sign up with social media</div>
                            <div className="visible-xs status-normal social-text">Or log in with</div>
                            <div className="social-login-buttons social-login-buttons-buy-sell-flow">
                                <button
                                    type="button"
                                    className="social-button social-button-google social-button-buy-sell-flow"
                                    onClick={() => this.doSocialLogin('google')}>
                                    <img src={global.imageBaseUrl + 'oneall/google-icon.svg'} alt="Google logo" />
                                    <img
                                        className="google-text"
                                        src={global.imageBaseUrl + 'oneall/google-text.svg'}
                                        alt="Log in with Google"
                                    />
                                </button>
                                <button
                                    type="button"
                                    className="social-button social-button-facebook social-button-buy-sell-flow"
                                    onClick={() => this.doSocialLogin('facebook')}>
                                    <img src={global.imageBaseUrl + 'oneall/facebook-icon.svg'} alt="Facebook logo" />
                                    <img
                                        className="facebook-text"
                                        src={global.imageBaseUrl + 'oneall/facebook-text.svg'}
                                        alt="Log in with Facebook"
                                    />
                                </button>
                                <button
                                    type="button"
                                    className="social-button social-button-linkedin social-button-buy-sell-flow"
                                    onClick={() => this.doSocialLogin('linkedin')}>
                                    <img src={global.imageBaseUrl + 'oneall/linkedin-icon.svg'} alt="Linkedin logo" />
                                    <img
                                        className="linkedin-text"
                                        src={global.imageBaseUrl + 'oneall/linkedin-text.svg'}
                                        alt="Log in with Facebook"
                                    />
                                </button>
                            </div>
                        </div>
                    )}
                    {window.SELL_SOCIAL_LOGIN_ENABLED && isPerformingSocialLogin && (
                        <div className="social-login-progress">
                            <div className="status-normal social-text">
                                Logging in with {PROVIDER_NAMES_BY_KEY[loginProvider || selectedLoginProvider]}...
                            </div>
                            <img className="spinner" src={global.imageBaseUrl + '/spinner.gif'} />
                        </div>
                    )}

                    {/* <div className="checkboxes-block">
                    <div className="secure-block">
                        <img src={global.imageBaseUrl + '/buysell/svg/secure.svg'} style="float: left"/>
                        <div>Your data is never shared without your consent.</div>
                    </div>
                    <div className="pretty p-svg p-plain">
                        <input ref={elem => this.refs.talkNow = elem} type="checkbox" checked="checked" name="talkNow"
                            onClick={() => this.wantToTalk()}/>
                        <div className="state p-default">
                            <svg className="svg svg-icon" viewBox="0 0 20 20" style={{'background-color': '#80878e'}}>
                                <path
                                    d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                    style="stroke: white;fill:white;"></path>
                            </svg>
                            <label>I want agents to contact me as soon as possible.</label>
                        </div>
                    </div>
                </div> */}
                </form>

                {(!window.SELL_SOCIAL_LOGIN_ENABLED || !loginProvider) && (
                    <button
                        type="button"
                        className="continue-button"
                        onClick={this.submit.bind(this)}
                        disabled={isNotValidEmail}>
                        Continue
                    </button>
                )}
                {window.SELL_SOCIAL_LOGIN_ENABLED && !!loginProvider && (
                    <button
                        type="button"
                        id={`continue-${loginProvider}-button`}
                        className="continue-button"
                        onClick={isLoggedIn ? this.submit.bind(this) : this.doSocialLogin.bind(this, loginProvider)}
                        disabled={isNotValidEmail}>
                        Continue with {loginProviderName}
                    </button>
                )}

                {isPhoneVisible && (
                    <div className="consent">
                        By clicking "Continue", I consent to UpNest’s{' '}
                        <a href="https://www.upnest.com/re/terms" target="_blank">
                            Terms of Service
                        </a>{' '}
                        and{' '}
                        <a href="https://www.realtor.com/privacy-policy/" target="_blank">
                            Privacy Policy
                        </a>
                        , and I consent to have UpNest or one of its partners contact me via auto-dialed phone calls,
                        text messages, and prerecorded messages, on the phone number I provided even if I'm on any
                        Do-Not-Call list and even if I am charged for the call or text. I understand that my consenting
                        is not a condition of my receiving UpNest services and that I can call{' '}
                        <span style="white-space: nowrap">1-800-692-5010</span> for services if I do not consent.
                    </div>
                )}

                <div className="flow-spacer" />
            </div>
        );
    }
}
